import Modal from "@components/Modal";
import { formatNumberToCurrency } from "@utils/formatNumber";

const valueColor = (value) => (value < 0 ? "#3CB371" : "#c0392b");
const fmtPeriod = (d) => (d ? d.split("-").reverse().join("/") : "");

const ExtraValuesMonthDetailModal = ({ monthLabel, entries = [], onSelectItem, close }) => {
  const expenses = entries.filter((e) => e.value > 0).reduce((a, b) => a + b.value, 0);
  const savings = entries.filter((e) => e.value < 0).reduce((a, b) => a + b.value, 0);
  const net = expenses + savings;

  return (
    <Modal close={close}>
      <div style={{ padding: "8px 4px", minWidth: "min(560px, 90vw)" }}>
        <h2 style={{ marginBottom: 4 }}>Lançamentos de {monthLabel}</h2>
        <p style={{ color: "#666", marginBottom: 16 }}>
          Como chegamos no valor do mês — cada parcela que cai em {monthLabel}.
        </p>

        <div className="flex gap-16 margin-bottom-16" style={{ flexWrap: "wrap" }}>
          <div><span style={{ color: "#666" }}>Despesas: </span><b style={{ color: valueColor(1) }}>{formatNumberToCurrency(expenses)}</b></div>
          <div><span style={{ color: "#666" }}>Economias: </span><b style={{ color: valueColor(-1) }}>{formatNumberToCurrency(savings)}</b></div>
          <div><span style={{ color: "#666" }}>Líquido: </span><b style={{ color: valueColor(net) }}>{formatNumberToCurrency(net)}</b></div>
        </div>

        <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
          {entries.map((entry, index) => (
            <button
              key={`${entry.wbs_code_id}-${index}`}
              onClick={() => onSelectItem?.(entry.wbs_code_id)}
              title="Ir para o item lançado"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: 8,
                width: "100%",
                textAlign: "left",
                padding: "10px 12px",
                borderBottom: "1px solid #eee",
                background: "transparent",
                cursor: "pointer",
              }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>{entry.item_name}</div>
                <div style={{ fontSize: ".8rem", color: "#666" }}>
                  {entry.description ? `${entry.description} · ` : ""}
                  parcela {entry.installment_index}/{entry.installments}
                  {entry.installments > 1 ? ` · ${fmtPeriod(entry.start_date)} a ${fmtPeriod(entry.end_date)}` : ""}
                </div>
              </div>
              <div style={{ fontWeight: 700, whiteSpace: "nowrap", alignSelf: "center", color: valueColor(entry.value) }}>
                {formatNumberToCurrency(entry.value)}
              </div>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ExtraValuesMonthDetailModal;
